import { render } from "./PaperChat.vue?vue&type=template&id=6096586c&scoped=true"
import script from "./PaperChat.vue?vue&type=script&lang=js"
export * from "./PaperChat.vue?vue&type=script&lang=js"

import "./PaperChat.vue?vue&type=style&index=0&id=6096586c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6096586c"]])

export default __exports__